import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import crm_router from "./CRM.js";
import frontend_router from "./Frontend.js";

const routes = [...frontend_router, ...crm_router];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      nextTick(() => {
        if (savedPosition) {
          window.LenisMain.scrollTo(savedPosition.top, { immediate: true });
          resolve(savedPosition)
        } else if (to.hash) {
          window.LenisMain.scrollTo(to.hash, { duration: 2 });
          resolve({ el: to.hash, behavior: "smooth", top: 65 })
        } else {
          if(from.name != to.name){
            window.LenisMain.scrollTo(0, { immediate: true });
          }else{
            window.LenisMain.scrollTo(0, { duration: 1 });
          }
          resolve({ top: 0, left: 0 })
        }
      });
    });
  },
});

export default router;
